











































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import {mapGetters} from "vuex";
import UserCredential = firebase.auth.UserCredential;
import RecaptchaVerifier = firebase.auth.RecaptchaVerifier;
import ConfirmationResult = firebase.auth.ConfirmationResult;


@Component({
    components: {},
    name: "SignIn",
    computed: {
        ...mapGetters({user: 'user', profile: 'profile', isCompany: 'isCompany', isWorker: 'isWorker'})
    }
})
export default class SignIn extends Vue {
    @Prop(String) readonly redirectUrl!: string;

    private signIn: boolean = false;
    private email: string = '';
    private phone: string = '';
    private password: string = '';
    private password1: string = '';
    private authType: 'email' | 'phone' = 'phone';
    private recaptchaVerifier?: RecaptchaVerifier;
    private recaptchaWidgetId?: number
    private confirmationResult: ConfirmationResult | false = false;
    private verificationCode: string = '';
    private errorMessage: string = ''
    private user?: any;
    private allowEmail: boolean = process.env.NODE_ENV == 'development'
    private recaptchaCode: string = ''

    private privacyChecked: boolean = false;

    @Watch('user')
    private watchUser(user: any) {
        if (user) {
            this.$nextTick(()=>{
                this.$router.push(this.redirectUrl || '/').catch(e => {});
            })

        }
    }

    private submit() {
        if (this.authType === 'email') {
            if (this.signIn) {
                this.$store.dispatch('signInWithEmailAndPassword', {
                    email: this.email, password: this.password
                }).catch((e: any) => {
                    this.errorMessage = e.message
                })
            } else {
                this.$store.dispatch('createUserWithEmailAndPassword', {
                    email: this.email, password: this.password
                }).catch((e: any) => {
                    this.errorMessage = e.message
                })
            }

        } else {
            this.$store.dispatch('signInWithPhoneNumber', {
                phoneNumber: '+39 ' + this.phone, appVerifier: this.recaptchaVerifier
            }).then((res: ConfirmationResult) => {
                this.confirmationResult = res;
            })
        }
    }

    private verifyCode() {
        if (this.confirmationResult) {
            this.confirmationResult.confirm(this.verificationCode).then((res: UserCredential) => {
                this.$store.dispatch('autoSignIn', res.user);
            }).finally(() => {
                this.verificationCode = '';
            }).catch((e: any) => {
                this.errorMessage = e.message
            })
        }
    }

    //@ts-ignore
    private getValidationState({dirty, validated, valid = null}) {
        return dirty || validated ? valid : null;
    }

    private retrySMS(){
        this.confirmationResult=false;
        (this.recaptchaVerifier as any).reset(this.recaptchaWidgetId);

    }

    private mounted() {
        this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
        this.recaptchaVerifier.render().then((recaptchaWidgetId) => {
            this.recaptchaWidgetId = recaptchaWidgetId;
        })
        this.recaptchaVerifier.verify().then((code) => {
            this.recaptchaCode = code;
        }).catch(() => {
            this.recaptchaCode = '';
        })

    }
}
